<app-vertical-tab-group>
  <app-vertical-tab
      *ngFor="let treatment of treatments.controls"
      [title]="'Treatment ' + treatment.value.treatmentNumber"
      [hasError]="treatment.get('flatInstructions').invalid">
    <div>
      <app-flat-instructions-form
      [options]="flatInstructionsOptions"
      [treatment]="treatment"
      #flatForm></app-flat-instructions-form>
    </div>

    <div class="text-right">
      <button class="btn btn-default" type="button" (click)="applyAll(flatForm)">
        Apply to All
      </button>
    </div>
  </app-vertical-tab>
</app-vertical-tab-group>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions.component.html